import { BaseModel } from '@tcc-mono/shared/data-access';
import { Stable } from './stable.model';

export class Veterinarian extends BaseModel {
  id: number;
  name: string;
  address?: string;
  zipcode?: string;
  city?: string;
  phone?: string;
  stables_count?: number;
  stables?: Stable[];
}
